import PixelateWorkerCode from '@workers/pixelate-worker-min.js';
export class PixelateWorker extends Worker {
    constructor() {
        super(PixelateWorker.getUrl());
    }
    static getUrl() {
        if (!this.url) {
            const blob = new Blob([PixelateWorkerCode], {
                type: 'application/javascript',
            });
            this.url = URL.createObjectURL(blob);
        }
        return this.url;
    }
}
Object.defineProperty(PixelateWorker, "url", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: ''
});
